import axios from 'axios'

// let baseUrl = process.env.NODE_ENV === 'development' ? 'https://goldeye.cfbond.com/' : 'https://goldeye.cfbond.com/'

// let pageBaseUrl = process.env.NODE_ENV === 'development' ? 'https://goldeneye.cfbond.com/' : 'https://goldeneye.cfbond.com/'

let baseUrl = process.env.NODE_ENV === 'development' ? 'https://a.cfbond.com/' : 'https://a.cfbond.com/'

let pageBaseUrl = process.env.NODE_ENV === 'development' ? 'https://a.cfbond.com/' : 'https://a.cfbond.com/'
// let baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/' : 'http://localhost:8080/'

// let pageBaseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/' : 'http://localhost:8080/'

let http = axios.create({
  timeout: 6000,
  baseURL: baseUrl
  // withCredentials: true
})

// 添加请求拦截器
http.interceptors.request.use(config => {
  // console.log('config',config)
  if (process.env.NODE_ENV === 'development') {
    config.url = '' + config.url
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

export {
  http,
  pageBaseUrl
}